import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import Markdown from "@/components/Markdown";
import styles from "./COADescription.module.scss";

const Description = ({ children, white = false, sx = {}, className = "" }) => (
  <Box
    className={`${white ? styles.white : ""} ${
      styles.description
    } ${className}`}
    sx={sx}
  >
    <Markdown>{children}</Markdown>
  </Box>
);

Description.propTypes = {
  children: PropTypes.node.isRequired,
  white: PropTypes.bool,
  sx: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string
};

export default Description;
